import { AiProviderCard } from '@/components/AiProviderCard';
import { ApiTokensCard } from '@/components/ApiTokensCard';
import { AppStoreConnectCard } from '@/components/AppStoreConnectCard';

/**
 * The two outside services this admin talks to: App Store Connect, and
 * whatever writes the translations. Each card is its own component with its
 * own spec; this screen only puts them in the design's order.
 *
 * ⚠️ Both cards keep the same four promises, and they are the reason a form
 * here is not worse than the env file it replaces: the stored values are
 * **encrypted at rest** under `SECRETS_ENCRYPTION_KEY`; **nothing reads a
 * secret back to the client** — a stored key comes back as "stored", or its
 * last four characters, or nothing; the `.p8` lives **nowhere a URL reaches**;
 * and every test **runs on the server**. The Overview's setup guide points
 * here; if this screen is ever removed, that guide has to go back to the
 * environment.
 */
export default function ConnectionsPage() {
  return (
    <div className="flex flex-col gap-3">
      <AppStoreConnectCard />
      <AiProviderCard />
      {/* The other direction: not a service this admin calls, but one that calls it. */}
      <ApiTokensCard />
    </div>
  );
}
